import type { SourcingAnswers } from './sourcingRecommendation'
import {
  emptySourcingAnswers,
  SourcingFeature,
  SourcingProcess,
  SourcingPurpose,
  SupplierVolume,
} from './sourcingRecommendation'

export const DUE_DILIGENCE_INTENT_SCHEMA_VERSION = 1

export type DueDiligenceIntentAnswers = {
  schemaVersion: number
  purpose?: string | null
  supplierVolume?: string | null
  process?: string | null
  needs: string[]
}

export type DueDiligenceIntent = {
  id: number
  organizationId: number
  answers: DueDiligenceIntentAnswers
  createdAt: string
  updatedAt?: string | null
}

const asOption = <TOption extends string>(options: TOption[], value: string | null | undefined): TOption | undefined =>
  options.find(option => option === value)

export function toDueDiligenceIntentAnswers(answers: SourcingAnswers): DueDiligenceIntentAnswers {
  return {
    schemaVersion: DUE_DILIGENCE_INTENT_SCHEMA_VERSION,
    purpose: answers.purpose ?? null,
    supplierVolume: answers.supplierVolume ?? null,
    process: answers.process ?? null,
    needs: answers.features,
  }
}

// Options the flow no longer offers are dropped rather than kept, so a renamed or removed answer
// cannot put the form into a state the user can't see or change.
export function toSourcingAnswers(stored: DueDiligenceIntentAnswers | undefined): SourcingAnswers {
  if (!stored) return emptySourcingAnswers

  return {
    purpose: asOption(Object.values(SourcingPurpose), stored.purpose),
    supplierVolume: asOption(Object.values(SupplierVolume), stored.supplierVolume),
    process: asOption(Object.values(SourcingProcess), stored.process),
    features: Object.values(SourcingFeature).filter(feature => stored.needs?.includes(feature)),
  }
}
